/**
 * Which register this browser is.
 *
 * The login screen names the terminal, the API requires it on every shift call, and a session
 * restored from storage has no principal terminal yet. Remembering the choice here — instead of
 * sending an empty value — keeps the till usable: the API answers a missing `terminalId` with a
 * validation error the operator can do nothing about, and the screen then shows three
 * contradictory states at once (checking, open-shift, failed).
 */

const KEY = 'sp.terminalId';

/** The first register, which every seeded deployment has. */
export const DEFAULT_TERMINAL_ID = 'terminal:1';

export function readTerminalId(): string {
  try {
    const stored = localStorage.getItem(KEY)?.trim();
    return stored && stored.length > 0 ? stored : DEFAULT_TERMINAL_ID;
  } catch {
    // A browser with storage disabled still has to reach the till.
    return DEFAULT_TERMINAL_ID;
  }
}

export function saveTerminalId(terminalId: string | null | undefined): void {
  const value = terminalId?.trim();
  if (!value) return;
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // Private mode: the default terminal still resolves, so nothing else is needed here.
  }
}
